export default {
    in_progress: {
        name: "In Progress",
        url: "nwcg_lines_repair_status/in_progress",
    },
    "in_use_-_fire_management": {
        name: "In Use - Fire Management",
        url: "nwcg_lines_repair_status/in_use_-_fire_management",
    },
    "other_-_see_comments": {
        name: "Other - See Comments",
        url: "nwcg_lines_repair_status/other_-_see_comments",
    },
    planned_road_as_line: {
        name: "Planned Road As Line",
        url: "nwcg_lines_repair_status/planned_road_as_line",
    },
    "repair_needed-1": {
        name: "Repair Needed-1",
        url: "nwcg_lines_repair_status/repair_needed-1",
    },
    repair_needed: {
        name: "Repair Needed",
        url: "nwcg_lines_repair_status/repair_needed",
    },
}
